<template>
    <v-layout column>
        <v-card tile flat>
            <v-card-text>
                <div :class = '`title pb-1 font-weight-light ${!$vuetify.theme.dark? "black--text":""}`'>Оповещения</div>
                <v-divider :color='$store.getters.uiAccent' class='my-1'></v-divider>
                <user-notification-controller :project='project' :canCreate='notificationCreateAllowed'></user-notification-controller>
                <div :class = '`title pb-1 font-weight-light ${!$vuetify.theme.dark? "black--text":""}`'>Схема отчета</div>
                <v-divider :color='$store.getters.uiAccent' class='my-1'></v-divider>
                <v-layout d-flex justify-center row align-content-space-between>
                    <v-layout d-flex column px-3>
                        <v-list class = 'py-0 my-0'>
                            <v-list-item v-if = 'indicator'>
                                <v-list-item-content>
                                    <v-progress-circular indeterminate width = '1' size = '24' :color = '$store.getters.uiAccent'></v-progress-circular>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-else 
                                @click = 'visibility.schema = !visibility.schema' 
                                :disabled = '(!exportConfigured && indicator) || project.mode_name != "Суперпользователь"'
                            >
                                <v-list-item-content>
                                    <v-list-item-title>Экспорт данных {{exportConfigured? "настроен": "не производится"}}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action class='mx-0'>
                                    <v-icon class='mr-1' color='blue darken-2'>mdi-tune</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-layout>
                </v-layout>
                <div :class = '`title pb-1 font-weight-light ${!$vuetify.theme.dark? "black--text":""}`'>Управление</div>
                <v-divider :color='$store.getters.uiAccent' class='my-1'></v-divider>
                <v-layout row px-3>
                    <v-btn depressed @click='visibility.update = true;' class = 'mr-1'>
                        <v-icon left>mdi-folder-edit-outline</v-icon>Редактировать описание
                    </v-btn>
                    <v-btn depressed color='grey accent-2' class = 'white--text mr-1 ml-auto' @click.prevent='archivate = true; visibility.delete = true;'>
                        <template v-if = 'project.active'>
                            <v-icon left>mdi-arrow-down-bold-box-outline</v-icon>Архивировать проект
                        </template>
                        <template v-else>
                            <v-icon left>mdi-arrow-up-bold-box-outline</v-icon>Деархивировать проект
                        </template>
                    </v-btn>
                    <v-btn depressed color='red accent-2' class = 'white--text ml-1' @click.prevent='visibility.delete = true;'>
                        <v-icon left>mdi-folder-remove-outline</v-icon>Удалить проект
                    </v-btn>
                </v-layout>
            </v-card-text>
        </v-card>
        <update-project-dialog :data = 'project' :initialState.sync = 'visibility.update'></update-project-dialog>
        <delete-project-dialog :data='project' :initialState='visibility.delete' :archive = 'archivate'></delete-project-dialog>
        <project-schema-controller :data = 'project' :initialState.sync = 'visibility.schema'></project-schema-controller>
    </v-layout>
</template>

<script>

import DeleteProjectDialog from '@/components/entities/projects/DeleteDialog.vue'
import UpdateProjectDialog from '@/components/entities/projects/UpdateDialog.vue'
import UserNotificationController from '@/components/entities/notifications/Controller.vue'
import ProjectSchemaController from '@/components/entities/projects/schema/SchemaController.vue'

import projectHandlers from '@/mixins/project'
import { orderBy } from 'lodash-es'

export default {
    name: 'ProjectSettings',
    props: ['data'],
    mixins: [projectHandlers],
    components: {
        'update-project-dialog': UpdateProjectDialog,
        'delete-project-dialog': DeleteProjectDialog,
        'user-notification-controller': UserNotificationController,
        'project-schema-controller': ProjectSchemaController
    },
    data() {
        return {
            visibility: {
                schema: false,
                update: false,
                delete: false
            },
            archivate: false,
            project: this.data,
            indicator: false,
            exportConfigured: false
        }
    },
    computed: {
        notificationCreateAllowed() {
            return this.project.mode_notifications != 'R'
        }
    },
    watch: {
        data(value) {
            this.project = value
            this.getProjectExportState()
        }
    },
    methods: {
        getProjectExportState() {
            this.indicator = true;
            this.getProjectPropertyPromise('readiness').then((r) => {
                let response = r.body
                this.indicator = false
                if (response.result) {
                    this.exportConfigured = response.data
                } else {
                    console.log('error fetch project export state', response.data)
                }
            });
        }
    },
    mounted() {
        this.getProjectExportState()
        this.$root.$on('projectDeleteDialogVisibility', (v) => {
            this.visibility.delete = v;
            if (!v) {
                this.archivate = false;
            }
        });
    }
}
</script>